function formatPhoneNumberToString(phone: string) {
  const digits = phone.replace(/\D/g, "");
  return `+${digits}`;
}

function formatPhoneNumber(phone: string) {
  // Eliminar todo lo que no sea número
  let digits = phone.replace(/\D/g, "");
  if(digits.length == 10) {
    digits = `52${digits}`;
  }

  if (digits.length < 11) {
    return "Número incompleto";
  }
  const isShortCountry = digits.length === 11;

  const country = digits.slice(0, isShortCountry ? 1 : 2);
  const part1 = digits.slice(isShortCountry ? 1 : 2, isShortCountry ? 4 : 5);
  const part2 = digits.slice(isShortCountry ? 4 : 5, isShortCountry ? 7 : 8);
  const part3 = digits.slice(isShortCountry ? 7 : 8, isShortCountry ? 11 : 12);

  return `+${country} ${part1}-${part2}-${part3}`;
}

function formatDate(timestamp: string) {
  const date = new Date(Number(timestamp) * 1000);
  return date.toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

function formatDateDate(utcDateString: string) {
  const date = new Date(utcDateString);
  const localFormatted = date.toLocaleString('es-MX', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  return localFormatted;
}

function formatDateFromUTC(utc: string) {
  const formatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    //timeZone: "UTC", // opcional: asegura que se use UTC
  });

  const time = formatter.format(new Date(utc));
  return time;
}

export {
  formatPhoneNumberToString,
  formatDateFromUTC,
  formatPhoneNumber,
  formatDateDate,
  formatDate,
};
